import { useEffect } from 'react'

import { scrollToSelector } from '@utility/index'

/**
 * Scrolls to the given selector (if found) or to the top of the page on mount.
 * @param selector CSS selector string. Defaults to 'body'.
 * @param block ScrollLogicalPosition for block alignment. Defaults to 'start'.
 * @param inline ScrollLogicalPosition for inline alignment. Defaults to 'nearest'..
 */
export interface UseScrollToTopOnMountOptions {
  selector?: string
  block?: ScrollLogicalPosition
  inline?: ScrollLogicalPosition
  dependency?: string
}

export const useScrollToTopOnMount = (options: UseScrollToTopOnMountOptions = {}) => {
  const {
    selector = 'body',
    block = 'start',
    inline = 'nearest',
    dependency,
  } = options
  useEffect(() => {
    const timer = setTimeout(() => {
      if (selector && document.querySelector(selector)) {
        scrollToSelector(selector, block, inline)
      } else if (typeof window !== 'undefined') {
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
      }
    }, 100)
    return () => clearTimeout(timer)
  }, [selector, block, inline, dependency])
}
